// extracted by mini-css-extract-plugin
module.exports = {"inline-link":"InlineLink_inline-link__H0fji"};